<template>
  <div class="widgets-panel">
    <Widget title="Simple card" event="addTipTapEditor" :width="24" :height="18" />
    <Widget title="Table" event="addTable" :width="24" :height="18" />
    <Widget
      title="Row editor"
      event="showAddDataGridEditRowFormModal"
      :width="12"
      :height="14"
    />
    <Widget title="Single card" :width="12" :height="6" />
    <Widget
      title="Filtered list"
      event="showAddWidgetModal"
      eventData="card-list"
      :width="12"
      :height="6"
    />
    <Widget title="Chart" event="showAddChartModal" :width="12" :height="6" />
    <Widget title="Gantt Chart" event="addGanttChart" :width="24" :height="18" />
    <Widget title="Gantt Simple" event="addGanntSimple" :width="24" :height="18" />
    <Widget title="Kanban" event="addKanbanData" :width="24" :height="18" />
    <Widget title="Calendar" event="showAddFullCalendarModal" :width="24" :height="36" />
    <!-- <Widget title="Data widget" event="addSpreadsheet" /> -->
    <Widget title="Spreadsheet" event="addSpreadsheet" :width="12" :height="5" /> 
    <Widget title="Pivot table" event="showAddPivotTableModal" :width="5" :height="4" />
    <Widget title="Post" event="showAddPostsWidgetModal" :width="5" :height="4" />
    <!-- Modals -->
    <AddDataGridModal />
    <AddKanbanModal />
    <!-- /Modals -->
  </div>
</template>

<script>
import Widget from './Widget'
// modals
import AddDataGridModal from './modals/AddDataGrid'
import AddKanbanModal from './modals/AddKanban'

export default {
  name: 'WidgetsPanel',
  components: {
    Widget,
    // modals
    AddDataGridModal,
    AddKanbanModal,
  },
}
</script>

<style scoped>
.widgets-panel {
  height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  background-color: #f4f5fb;

  overflow: auto;
}

.widgets-panel::-webkit-scrollbar {
  display: none;
}
</style>
